import { render, staticRenderFns } from "./EditSite.vue?vue&type=template&id=118cd542&"
import script from "./EditSite.vue?vue&type=script&lang=ts&"
export * from "./EditSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports